import { Func, Predicate } from '../types';

export function ifElse<A, T, F>(
    condition: Predicate<[A]>,
    onTrue: Func<[A], T>,
    onFalse: Func<[A], F>
): Func<[A], T | F>;
export function ifElse<A1, A2, T, F>(
    condition: Predicate<[A1, A2]>,
    onTrue: Func<[A1, A2], T>,
    onFalse: Func<[A1, A2], F>
): Func<[A1, A2], T | F>;
export function ifElse<A1, A2, A3, T, F>(
    condition: Predicate<[A1, A2, A3]>,
    onTrue: Func<[A1, A2, A3], T>,
    onFalse: Func<[A1, A2, A3], F>
): Func<[A1, A2, A3], T | F>;
export function ifElse<A extends unknown[], T, F>(
    condition: Predicate<A>,
    onTrue: Func<A, T>,
    onFalse: Func<A, F>
): Func<A, T | F>;

export function ifElse<A extends unknown[], T, F>(condition: Predicate<A>, onTrue: Func<A, T>, onFalse: Func<A, F>) {
    return (...args: A) => (condition(...args) ? onTrue(...args) : onFalse(...args));
}
